import React from "react";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <section className="footer-container">
      <div className="footer">
        <div className="footer-info">
          <h3>{t("footer.title")}</h3>
          <a
            href="mailto:info@fazadcheshk.com"
            target="_blank"
            rel="noreferrer"
          >
            <h4>info@farzadcheshk.com</h4>
          </a>
        </div>
        <div className="footer-social">
          <div className="social">
            <a
              href="/"
              target="_blank"
              rel="noreferrer"
              aria-label="Follow me on LinkedIn"
              title="Follow me on LinkedIn"
            >
              {t("footer.social1")}
            </a>
            <img
              alt="Arrow icon"
              className="arrow-svg-icon"
              src="/images/icon-arrow.svg"
              role="img"
            ></img>
          </div>
          <div className="social">
            <a
              href="https://www.instagram.com/farzad.cheshk"
              target="_blank"
              rel="noreferrer"
              aria-label="Follow me on Instagram"
              title="Follow me on Instagram"
            >
              {t("footer.social2")}
            </a>
            <img
              alt="Arrow icon"
              className="arrow-svg-icon"
              src="/images/icon-arrow.svg"
              role="img"
            ></img>
          </div>
          <div className="social">
            <a
              href="/"
              target="_blank"
              rel="noreferrer"
              aria-label="Follow me on YouTube"
              title="Follow me on YouTube"
            >
              {t("footer.social3")}
            </a>
            <img
              alt="Arrow icon"
              className="arrow-svg-icon"
              src="/images/icon-arrow.svg"
              role="img"
            ></img>
          </div>
        </div>
      </div>
      <div className="socket">
        <div className="footer-copyright">
          <p>© {currentYear} Farzad Cheshk</p>
        </div>
        <div className="footer-location">
          <p>Düsseldorf, Germany</p>
          <a
            href="https://10110.dev/utm_source=farzadcheshk&utm_medium=website&utm_campaign=speaker"
            target="_blank"
            rel="noreferrer"
          >
            <img src="/images/logo-10110.svg" alt="10110.dev Logo" role="img" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default Footer;
